var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCameraCardIcon6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.30798 10.6241C5.93673 10.435 5.52346 10.337 5.10318 10.337C1.82498 10.5681 1.82498 15.3383 5.10318 15.5695H12.8714C13.817 15.5765 14.7276 15.2262 15.4211 14.5888C17.7256 12.5785 16.4928 8.53675 13.4598 8.15149C12.367 1.5881 2.88969 4.08177 5.1382 10.337",
    fill: "url(#paint0_linear_1389_9525)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1389_9525)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.7841 12.0555C10.4499 12.3102 10.043 12.4513 9.62293 12.4582C8.25457 12.4582 7.47266 10.8943 7.47266 10.8943C7.71581 10.4412 8.05306 10.0453 8.46178 9.7332M9.21242 9.37743C9.34698 9.34593 9.48474 9.33019 9.62293 9.33051C10.9913 9.33051 11.7732 10.8943 11.7732 10.8943C11.6545 11.1163 11.513 11.3253 11.351 11.5179M10.0373 11.3088C9.98366 11.3664 9.91892 11.4126 9.84698 11.4446C9.77504 11.4767 9.69739 11.4939 9.61865 11.4953C9.53991 11.4967 9.46169 11.4822 9.38867 11.4527C9.31565 11.4232 9.24932 11.3793 9.19363 11.3237C9.13794 11.268 9.09404 11.2016 9.06455 11.1286C9.03505 11.0556 9.02057 10.9774 9.02196 10.8986C9.02334 10.8199 9.04058 10.7422 9.07263 10.6703C9.10468 10.5984 9.1509 10.5336 9.20851 10.4799",
    stroke: "white",
    strokeWidth: 0.390959,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.47266 8.74408L11.7732 13.0446",
    stroke: "white",
    strokeWidth: 0.390959,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1389_9525",
    x1: 9.01652,
    y1: 4.28094,
    x2: 8.06489,
    y2: 18.2506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2FDAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF8DFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1389_9525"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.69151,
    height: 4.69151,
    fill: "white",
    transform: "translate(7.27734 8.54858)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraCardIcon6);
export default __webpack_public_path__ + "static/media/camera_card_icon6.9e598fcfb42bc6509756fb2b974719f3.svg";
export { ForwardRef as ReactComponent };